import Card from '@zenbusiness/zui/Card';
import Link from '@zenbusiness/zui/Link';
import { superstyled } from '@zenbusiness/zui/styles';

export const RelatedProductLink = superstyled({
  tag: Link,
  name: 'RelatedProductsSection',
  slot: 'RelatedProductLink',
  styles: {
    textDecoration: 'none',
  },
});

export const RelatedProductCard = superstyled({
  tag: Card,
  name: 'RelatedProductsSection',
  slot: 'RelatedProductCard',
  styles: ({ theme }) => ({
    padding: theme.spacing(2),
  }),
});
